module.exports = __webpack_public_path__ + "media/images/icon-student-92d628af82dcd369b0eea6c585774250.svg";